import { render, staticRenderFns } from "./CostingTable.vue?vue&type=template&id=f03b86ac&scoped=true&"
import script from "./CostingTable.vue?vue&type=script&lang=js&"
export * from "./CostingTable.vue?vue&type=script&lang=js&"
import style0 from "./CostingTable.vue?vue&type=style&index=0&id=f03b86ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03b86ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VContainer})
